import React from 'react';
import { SvgIconComponent } from '@cp/ds/src/components/svgIcon';
import { Stack } from '@cp/ds/src/components/stack';
import { Box } from '@cp/ds/src/components/box';
import { Link } from '@cp/ds/src/components/link';
import { Typography } from '@cp/ds/src/components/typography';
import { SxProps } from '@cp/ds/src/theme';

export type SocialMediaItem = { icon: SvgIconComponent; href?: string; name: string };
export interface SocialMediaListProps {
  media: SocialMediaItem[];
  sx?: SxProps;
}
export const SocialMediaList = ({ media, ...props }: SocialMediaListProps) => (
  <Stack {...props}>
    {media.map(({ name, icon, href }) => {
      const Icon = icon;
      return (
        <Box
          key={name}
          sx={{
            display: 'flex',
            alignItems: 'center',
            width: 'fit-content',
            mb: 2.6,
          }}
        >
          <Icon sx={{ fontSize: 40 }} />
          <Link external href={href} underline={false}>
            <Typography sx={{ ml: 2 }} variant="button">
              {name}
            </Typography>
          </Link>
        </Box>
      );
    })}
  </Stack>
);
